export const BRAND = {
  name: "AR POS SYSTEM",
  short: "AR",
  website: "https://poslebanon.co",
  email: "admin@poslebanon.co",
  phone: "+961 76332499",
  colors: {
    primary: "#2563EB",
    primaryHover: "#1D4ED8",
    gold: "#F6C343",
    dark: "#0B1F4D",
    bg: "#F8FAFC",
    surface: "#FFFFFF",
    border: "#CBD5E1",
    text: "#0F172A",
    textSecondary: "#475569",
    success: "#16A34A",
    warning: "#D97706",
    danger: "#DC2626",
  },
  logos: {
    wordmark: "/logo_wordmark.png",
    compact: "/logo_compact.png",
    icon: "/icon_512x512.png",
    favicon: "/favicon.ico",
  },
};
